export const POLARIS_OAUTH_CLIENT_ID = 'polaris';
export const POLARIS_UNSUPPORTED_OAUTH_CLIENT_ID = 'polaris-unsupported-url';

export const isInternalOauthClientId = (oauthClientId: string) =>
	oauthClientId === POLARIS_OAUTH_CLIENT_ID ||
	oauthClientId === POLARIS_UNSUPPORTED_OAUTH_CLIENT_ID;

export const isUnsupportedUrlOauthClientId = (oauthClientId: string) =>
	oauthClientId === POLARIS_UNSUPPORTED_OAUTH_CLIENT_ID;
